import React from 'react';
import NumberInput from '@teetsh/app/src/components/Form/NumberInput';

interface Props {
  value?: number;
  onChange: (v?: number) => void;
}

export function NumberCustomField(props: Props) {
  const { value, onChange } = props;

  return <NumberInput emptyValue="" value={value} onChange={onChange} />;
}
